import {defineMessages} from "@project/i18n";

export const leadFieldLabelIds = {
  active: "fields.lead.active",
  address: "fields.lead.address",
  companyName: "fields.lead.companyName",
  country: "fields.lead.country",
  logoUrl: "fields.lead.logoUrl",
  phoneNumber: "fields.lead.phoneNumber",
  phonePrefix: "fields.lead.phonePrefix",
  type: "fields.lead.type",
  websiteUrl: "fields.lead.websiteUrl",
} as const;

export const leadFieldMessages = defineMessages({
  active: {
    id: "fields.lead.active",
    defaultMessage: "Active",
    description: "Lead field label for active status",
  },
  address: {
    id: "fields.lead.address",
    defaultMessage: "Address",
    description: "Lead field label for postal address",
  },
  companyName: {
    id: "fields.lead.companyName",
    defaultMessage: "Company name",
    description: "Lead field label for company name",
  },
  country: {
    id: "fields.lead.country",
    defaultMessage: "Country",
    description: "Lead field label for country",
  },
  logoUrl: {
    id: "fields.lead.logoUrl",
    defaultMessage: "Logo URL",
    description: "Lead field label for logo URL",
  },
  phoneNumber: {
    id: "fields.lead.phoneNumber",
    defaultMessage: "Phone number",
    description: "Lead field label for phone number",
  },
  phonePrefix: {
    id: "fields.lead.phonePrefix",
    defaultMessage: "Phone prefix",
    description: "Lead field label for phone prefix",
  },
  type: {
    id: "fields.lead.type",
    defaultMessage: "Lead type",
    description: "Lead field label for lead type",
  },
  websiteUrl: {
    id: "fields.lead.websiteUrl",
    defaultMessage: "Website URL",
    description: "Lead field label for website URL",
  },
});
